export const seoKeywords = {
  name: 'keywords',
  content:
    'mobile app development, mobile development company, mobile app services, iOS app development, android app development, react native development, mobile developers to hire, mobile development, custom app development',
};

export const mobileDevelopmentPageSeo = {
  title: 'Custom iOS and Android app development | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Mobile app development with Rumble Fish guarantees the highest quality of your application. We’ve got expertise in developing custom apps for both iOS and Android. Our talented engineers take full ownership of the project and lead the entire mobile app development process from start to finish.',
    },
  ],
};
